// Member-facing perk lines derived from the backend privileges resolver (user.privileges.hints) — never from the
// admin cards directly, so Admin › Privilèges › Règles d'attribution drives every reminder / perk list.
const n = (v) => Number(v || 0);

export const isCreatorCategory = (cat) => ["preacher", "artist", "influencer"].includes(cat);

// Lines for « what THEN unlocks compared to NOW » (limits + premium fields).
export const profileBenefits = (now, then, t) => {
  if (!now || !then) return [];
  const out = [];
  const uMin = n(now.min_followers_live), vMin = n(then.min_followers_live);
  if (then.can_go_live !== false && (vMin < uMin || now.can_go_live === false)) {
    out.push(vMin > 0 ? t("privileges.benefit_live_min", "Passe en direct dès {n} abonné(s)").replace("{n}", vMin) : t("privileges.benefit_live_nomin", "Passe en direct sans minimum d'abonnés"));
  }
  const uDur = n(now.max_live_duration_min), vDur = n(then.max_live_duration_min);
  if (vDur === 0 && uDur !== 0) out.push(t("privileges.benefit_duration_unlimited", "Directs sans limite de durée"));
  else if (vDur > uDur) out.push(t("privileges.benefit_duration", "Directs jusqu'à {n} min").replace("{n}", vDur));
  const uFol = n(now.max_followers), vFol = n(then.max_followers);
  if (vFol === 0 && uFol !== 0) out.push(t("privileges.benefit_followers_unlimited", "Abonnés illimités"));
  else if (vFol > uFol) out.push(t("privileges.benefit_followers", "Jusqu'à {n} abonnés").replace("{n}", vFol.toLocaleString()));
  if (then.can_post_videos !== false && now.can_post_videos === false) out.push(t("privileges.benefit_videos", "Publie des vidéos dans le fil"));
  if (then.can_create_ads !== false && now.can_create_ads === false) out.push(t("privileges.benefit_ads", "Crée des publicités"));
  const uSt = n(now.max_stories_per_day), vSt = n(then.max_stories_per_day);
  if (vSt === 0 && uSt !== 0) out.push(t("privileges.benefit_stories_unlimited", "Stories illimitées"));
  else if (vSt > uSt && uSt !== 0) out.push(t("privileges.benefit_stories", "Jusqu'à {n} stories / jour").replace("{n}", vSt));
  return out;
};

// Money items: `then` = with the step alone, `thenBoth` = with the step AND the other condition (badge ⇄ identity).
// → [{key: "offerings"|"withdraw", withOther: bool, text}]
export const moneyBenefits = (now, then, thenBoth, otherLabel, t) => {
  const out = [];
  const add = (field, key, fallback) => {
    const label = t(`privileges.benefit_${key}`, fallback);
    if (then?.[field] && !now?.[field]) out.push({ key, withOther: false, text: label });
    else if (!then?.[field] && thenBoth?.[field] && !now?.[field]) out.push({ key, withOther: true, text: `${label} ${t("privileges.benefit_with_other", "(avec {other})").replace("{other}", otherLabel)}` });
  };
  add("can_receive_offerings", "offerings", "Reçois des offrandes et dons pendant tes directs");
  add("can_withdraw", "withdraw", "Retire tes gains");
  return out;
};

// Everything a step (badge | identity) would change for the member, as lines.
export const stepBenefits = (priv, step, t) => {
  const h = priv?.hints;
  const s = h?.[step];
  if (!h || !s) return { lines: [], money: [], unlocks: false };
  const other = step === "badge" ? t("privileges.other_identity", "ton identité vérifiée") : t("privileges.other_badge", "Yalola Vérifié");
  const lines = profileBenefits(h.now, s.then, t);
  const money = moneyBenefits(h.now, s.then, step === "badge" ? s.then_with_identity : s.then_with_badge, other, t);
  return { lines, money, unlocks: lines.length > 0 || money.length > 0 };
};
